/* eslint-disable */

import axios from "./index";

// 获取地址配置 （中心点、缩放级别）
function getMapConfig() {
  return axios.post("/systemConfig/getMultiValue", [
    "BIG_SCREEN_CENTER_LNG",
    "BIG_SCREEN_CENTER_LAT",
    "BIG_SCREEN_ZOOM"
  ]);
}

// 获取机构列表
function getOrganizationsForMap(type = 3) {
  return axios.get("/organization/getAllForMap?type=" + type);
}

// 获取机构详情
function getOrganization(organizationId) {
  return axios.get(
    "/organization/getOrganization?organizationId=" + organizationId
  );
}

// 获取指定机构的摄像头
function getCamerasByOrganization(organizationId) {
  return axios.get(
    "/iotDevice/getCamerasByOrganization?organizationId=" + organizationId
  );
}

// 产废企业总量TOP
function getOutputTopN(n = 5) {
  return axios.get("/organization/getOutputTopN?n=" + n);
}

// 获取危废类别产量排名TOP
function getHwItemOutputTopN(n = 5) {
  return axios.get("/analyze/getHwItemOutputTopN?n=" + n);
}

// 获取危废月产量（同比)，缺省：当前年度-2 至 当前年度
function getManufactureMonthly() {
  return axios.get("/analyze/getManufactureMonthly");
}

// 获取危废月产量增长率（环比）
function getManufactureMonthlyGrowth() {
  return axios.get("/analyze/getManufactureMonthlyGrowth");
}

// 获取报警类型总量
function getAlarmTotal() {
  return axios.get("/alarm/getTotal");
}

// 获取报警类型总量
function getAlarmTopNUnhandled(n = 10) {
  return axios.get("/alarm/getTopNUnhandled?n=" + n);
}


// 获取指定年度产生的危废类别列表
function getAllHwItems(year = 0) {
  return axios.get("/analyze/getAllHwItems?year=" + year);
}

// 获取分析总量（大屏）
function getApplicationTotal() {
  return axios.get("/analyze/getTotal");
}

// 根据机构Id获取最新的快照图片集合（大屏）
function getTopByOrganization(organizationId, top) {
  return axios.get(
    "/cameraSnapshot/getTopByOrganization?organizationId=" +
    organizationId +
    "&top=" + top
  );
}

function login(login) {
  return axios.post("/user/loginBigScreen", login);
}

// 获取指定企业的产废流向数据（大屏）
function getTransportYearly(organizationId) {
  return axios.get("/analyze/getTransportYearly?organizationId=" + organizationId);
}

// 获取指定企业的产废类别饼图数据（大屏）
function getManufactureYearly(organizationId) {
  return axios.get("/analyze/getManufactureYearly?organizationId=" + organizationId);
}

// 获取指定企业的危废库存数据（大屏）
function getInventory(organizationId) {
  return axios.get("/analyze/getInventory?organizationId=" + organizationId);
}

// 获取流程图
function getFlowChartByHwCode(organizationId, hwCode2, type, alias) {
  return axios.get("/organization/getFlowChartByHwCode?organizationId=" + organizationId + "&hwCode2=" + hwCode2 + "&type=" + type + "&alias=" + alias);
}

// 获取企业的首个暂存库 (未缓存)
function getFirstByOrganization(organizationId) {
  return axios.get("/storeHouse/getFirstByOrganization?organizationId=" + organizationId);
}

// 获取指定企业的报警分页列表
function getAlarmList(organizationId) {
  return axios.get("/alarm/getPagedListByOrganization?organizationId=" + organizationId + "&pageIndex=1&pageSize=20");
}

// 获取指定预警的生命周期日志集合
function getAlarmLifeCycleLogs(alarmId) {
  return axios.get("/alarm/getLifeCycleLogs?alarmId=" + alarmId);
}

// 获取指定企业的联单分页列表
function getManifestList(organizationId) {
  return axios.get("/hwManifest/getPagedListByOrganization?organizationId=" + organizationId + "&pageIndex=1&pageSize=20");
}

// 获取指定联单的生命周期日志集合
function getManifestLifeCycleLogs(hwManifestId) {
  return axios.get("/hwManifest/getLifeCycleLogs?hwManifestId=" + hwManifestId);
}

// 获取危废月产量同环比
function getManufactureTwoYearGrowth(organizationId) {
  return axios.get("/analyze/getManufactureTwoYearGrowth?organizationId=" + organizationId);
}

// 获取指定企业的产废类别预测（半年）数据
function getManufactureMonthlyForecast(organizationId) {
  return axios.get("/analyze/getManufactureMonthlyForecast?organizationId=" + organizationId);
}

// 获取危废来源
function getHwSourceList(ids) {
  return axios.post("/hwSource/getList", ids);
}

// 获取企业快照
function getLastGroupByOrganization(top) {
  return axios.get("/cameraSnapshot/getLastGroupByOrganization?top=" + top);
}

// 获取摄像头快照
function getLastGroupByIoTDevice(top) {
  return axios.get("/cameraSnapshot/getLastGroupByIoTDevice?top=" + top);
}

// 获取企业摄像头token
function getFirstCameraByOrganization(organizationId) {
  return axios.get("/iotDevice/getFirstCameraByOrganization?organizationId=" + organizationId);
}

// 获取企业摄像头token
function getWithToken(iotDeviceId) {
  return axios.get("/iotDevice/getWithToken?iotDeviceId=" + iotDeviceId);
}

// 获取企业摄像头token
function analyzeOrgInOut() {
  return axios.get("/analyze/analyzeOrgInOut");
}

// 处置台账
function getStandingBookDisposal(organizationId) {
  return axios.get("/hwManifest/getStandingBookDisposal?organizationId=" + organizationId);
}

// 转移台账
function getStandingBookTransfer(organizationId) {
  return axios.get("/hwManifest/getStandingBookTransfer?organizationId=" + organizationId);
}

// 入库台账
function getStandingBookInStorage(organizationId) {
  return axios.get("/analyze/getStandingBookInStorage?organizationId=" + organizationId);
}
//考核结果
function getAssess(year) {
  return axios.get("/assess/getDpData?year=" + year);
}

export default {
  getMapConfig,
  getOrganizationsForMap,
  getOrganization,
  getCamerasByOrganization,
  getOutputTopN,
  getHwItemOutputTopN,
  getManufactureMonthly,
  getManufactureMonthlyGrowth,
  getAlarmTotal,
  getAlarmTopNUnhandled,
  getApplicationTotal,
  getTopByOrganization,
  login,
  getTransportYearly,
  getManufactureYearly,
  getInventory,
  getFlowChartByHwCode,
  getFirstByOrganization,
  getAlarmList,
  getAlarmLifeCycleLogs,
  getManifestList,
  getManifestLifeCycleLogs,
  getManufactureTwoYearGrowth,
  getManufactureMonthlyForecast,
  getHwSourceList,
  getLastGroupByOrganization,
  getLastGroupByIoTDevice,
  getFirstCameraByOrganization,
  getAllHwItems,
  analyzeOrgInOut,
  getStandingBookDisposal,
  getStandingBookTransfer,
  getStandingBookInStorage,
  getWithToken,
  getAssess
};
